// extracted by mini-css-extract-plugin
module.exports = {"image-avatar-border":"Image_image-avatar-border__3czRk"};